// extracted by mini-css-extract-plugin
export default {"label":"QuoteHeader_label__AzOWJ"};